export const useCapstone = (slug) => {
    const prevYearCapstoneSlugs = ['apseminartraining', 'apresearchtraining']
    const currentYearCapstoneSlugs = ['apseminarcertification', 'apresearchcertification']
    const isPrevCapstone = prevYearCapstoneSlugs.filter(s => s === slug).length === 1
    const isCurrCapstone = currentYearCapstoneSlugs.filter(s => s === slug).length === 1
    const capstoneFlag = flag.all()["fy_22316_enable_capstone_for_ed_period_23"]

    return {
        isPrevCapstone,
        isCurrCapstone,
        capstoneFlag
    }

}

export const subjectFind = (subject, params, query) => {
    if (query && query.calcbc) {
        return subject.id === 26;
    } else {
        return subject.pl_slug === params.course
    }
}



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/apps/pl/utils.js
 **/